import { Card, CardContent, CardHeader } from "@repo/ui";

function SkeletonBar({ className = "" }: { className?: string }) {
  return <div className={`animate-pulse rounded-md bg-muted ${className}`} />;
}

export function AnalyticsSkeleton() {
  return (
    <div className="space-y-6">
      {/* Status Cards Skeleton */}
      <div className="grid gap-4 md:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <Card key={i}>
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div className="space-y-2">
                  <SkeletonBar className="h-3 w-20" />
                  <SkeletonBar className="h-8 w-12" />
                </div>
                <SkeletonBar className="h-10 w-10 rounded-lg" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Trends Chart Skeleton */}
      <Card>
        <CardHeader>
          <SkeletonBar className="h-5 w-40" />
          <SkeletonBar className="h-3 w-60" />
        </CardHeader>
        <CardContent>
          <SkeletonBar className="h-[300px] w-full" />
        </CardContent>
      </Card>

      {/* Top Items Skeleton */}
      <div className="grid gap-4 md:grid-cols-2">
        {Array.from({ length: 2 }).map((_, i) => (
          <Card key={i}>
            <CardHeader>
              <SkeletonBar className="h-5 w-40" />
              <SkeletonBar className="h-3 w-48" />
            </CardHeader>
            <CardContent>
              <SkeletonBar className="h-[280px] w-full" />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
